import { buildProjectsOverviewFilterDocument } from '@griply/utils';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useProjectsOverviewFilterDocument = () => {
  const user = useUser();
  return useMemo(
    () => buildProjectsOverviewFilterDocument(user?.settings),
    [user?.settings],
  );
};
